import axiosFetch from './config';

export const getNotifications = async(status, page)=>{
    let token = await localStorage.getItem('token')
    return axiosFetch({
      method:'GET',
      url: `/messages/notifications?typeOfNotification=${status}&page=${page}`,
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}

export const putNotificationStatus = async(id, data)=>{
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method:'PUT',
    url: `/messages/notifications/${id}`,
    data,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const markNotificationsAsRead = async()=>{
    return axiosFetch({
      method:'PUT',
      url:  `/messages/notifications`,
      headers: {
        Authorization: 'Bearer ' + await localStorage.getItem('token'),
      }
    })
}

export const deleteNotificationById = async(id)=>{
    let token = await localStorage.getItem('token')
    return axiosFetch({
      method:'DELETE',
      url: `/messages/notifications/${id}`, 
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}